/* eslint-disable import/prefer-default-export */
export const GET_AMBASSADORS_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
